"use strict";

var _fileSaver = _interopRequireDefault(require("file-saver"));

var _FDSENS = _interopRequireDefault(require("../FDS-ENS2.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

class User {
  constructor(attrs, Account) {
    if (attrs.subdomain === undefined) throw new Error('subdomain must be defined');
    if (attrs.wallet === undefined) throw new Error('wallet must be defined');
    this.Account = Account;
    this.Mail = this.Account.Mail;
    this.Tx = this.Account.Tx;
    this.SwarmStore = this.Account.SwarmStore;
    this.version = attrs.version || undefined;
    this.subdomain = attrs.subdomain;
    this.wallet = attrs.wallet;
    this.nonce = false;
    return this;
  }

  syncNonce() {
    return this.Tx.syncNonce(this).then(nonce => {
      this.nonce = nonce;
    });
  }

  toJSON() {
    return {
      subdomain: this.subdomain,
      wallet: this.wallet,
      version: this.version
    };
  }

  sign(message) {
    return this.Tx.sign(this, message);
  }

  recover(message, sig) {
    return this.Tx.recover(message, sig);
  }

  deployContract(abi, bytecode) {
    var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var nonce = arguments.length > 3 ? arguments[3] : undefined;
    var gas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 6000000;
    return this.Tx.deployContract(this, abi, bytecode, args, nonce, gas);
  }

  getContract(abi, address) {
    return this.Tx.getContract(this, abi, address);
  }
  /**
   * Send file
   * @param {any} recipientSubdomain name
   * @param {any} file to send
   * @param {any} encryptionCallback callback
   * @param {any} uploadCallback callback
   * @param {any} progressMessageCallback callback
   * @returns {any} result
   */


  send(recipientSubdomain, file, multiboxPath) {
    var encryptionCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : console.log;
    var uploadCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : console.log;
    var progressMessageCallback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : console.log;
    return this.Mail.send(this, recipientSubdomain, file, multiboxPath, encryptionCallback, uploadCallback, progressMessageCallback);
  }
  /**
   * send tokens
   * @param {any} recipientAddress 0xfff
   * @param {any} amount in wei
   * @param {any} transactionCallback callback
   * @param {any} transactionSignedCallback callback
   * @returns {any} transaction
   */


  payAddress(recipientAddress, amount) {
    var gas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 6000000;
    var transactionCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : console.log;
    var transactionSignedCallback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : console.log;
    return this.Tx.pay(this, recipientAddress, amount, gas, transactionCallback, transactionSignedCallback);
  }
  /**
   * Send amount of tokens to subdomain
   * @param {any} subdomain to whom to send subdomain
   * @param {any} amount in wei
   * @returns {any} result
   */


  pay(recipientSubdomain, amount) {
    var _arguments = arguments,
        _this = this;

    return _asyncToGenerator(function* () {
      var gas = _arguments.length > 2 && _arguments[2] !== undefined ? _arguments[2] : 6000000;
      var transactionCallback = _arguments.length > 3 && _arguments[3] !== undefined ? _arguments[3] : console.log;
      var transactionSignedCallback = _arguments.length > 4 && _arguments[4] !== undefined ? _arguments[4] : console.log;
      var ENS = new _FDSENS.default(_this, _this.Account.config.ensConfig);
      var recipientAddress = yield ENS.getOwner(recipientSubdomain);
      return _this.payAddress(recipientAddress, amount, gas, transactionCallback, transactionSignedCallback);
    })();
  }
  /**
   * Send file
   * @param {any} recipientSubdomain name
   * @param {any} file to send
   * @param {any} encryptionCallback callback
   * @param {any} uploadCallback callback
   * @param {any} progressMessageCallback callback
   * @returns {any} result
   */


  getBalance() {
    return this.Tx.getBalance(this.address);
  }

  getBlockNumber() {
    return this.Tx.getBlockNumber();
  }
  /**
   * Receive file
   * @param {any} message that points to file
   * @param {any} decryptionCallback callback
   * @param {any} downloadCallback callback
   * @returns {any} returns file if success
   */


  receive(message) {
    var _arguments2 = arguments,
        _this2 = this;

    return _asyncToGenerator(function* () {
      var decryptionCallback = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : console.log;
      var downloadCallback = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : console.log;

      if (message.to === _this2.subdomain) {
        return yield _this2.Mail.receive(_this2, message, decryptionCallback, downloadCallback);
      } else if (message.from === _this2.subdomain) {
        return yield _this2.Mail.retrieveSent(_this2, message, decryptionCallback, downloadCallback);
      } else {
        throw Error('there was a problem...');
      }
    })();
  }
  /**
   * Get messages
   * @param {any} query to lookup to
   * @returns {any} available messages
   */


  messages() {
    var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'received';
    var multiboxPath = arguments.length > 1 ? arguments[1] : undefined;

    if (['received', 'sent'].indexOf(query) === -1) {
      throw new Error('must be of type received or sent');
    }

    return this.Mail.getMessages(query, this, multiboxPath);
  }
  /**
   * store value
   * @param {any} key to store under
   * @param {any} value to store
   * @returns {any} stored result
   */


  storeValue(key, value) {
    var pin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return this.SwarmStore.storeValue(key, value, this, pin);
  }
  /**
   * retrieve value
   * @param {any} key to lookup
   * @returns {any} retrieved value
   */


  retrieveValue(key) {
    return this.SwarmStore.retrieveValue(key, this);
  }
  /**
   * store encrypted value
   * @param {any} key to store under
   * @param {any} value to store
   * @returns {any} decrypted value if exists
   */


  storeEncryptedValue(key, value) {
    return this.SwarmStore.storeEncryptedValue(key, value, this, this.privateKey);
  }
  /**
   * retrieve decrypted value
   * @param {any} key to lookup
   * @returns {any} decrypted value if exists
   */


  retrieveDecryptedValue(key) {
    return this.SwarmStore.retrieveDecryptedValue(key, this.address, this.privateKey);
  }
  /** @returns {Contact} array of contacts */


  getContacts() {
    return this.SwarmStore.getContacts(this);
  }
  /**
   *
   * @param {Contact} contact to store
   * @returns {any} stored
   */


  storeContact(contact) {
    return this.SwarmStore.storeContact(this, contact);
  }
  /**
   * Store file
   * @param {any} file to store
   * @param {any} encryptionCallback callback
   * @param {any} uploadCallback callback
   * @param {any} progressMessageCallback callback
   * @returns {string} hash where stored
   */


  store(file) {
    var encryptionCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : console.log;
    var uploadCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console.log;
    var progressMessageCallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : console.log;
    var metadata = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var showManifestAddresses = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var pin = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    return this.SwarmStore.storeFile(this, file, encryptionCallback, uploadCallback, progressMessageCallback, metadata, showManifestAddresses, pin);
  }
  /**
   * access stored manifest
   */


  storedManifest() {
    return this.SwarmStore.getStoredManifest(this);
  }

  updateStoredManifest(manifest) {
    return this.SwarmStore.updateStoredManifest(manifest, this);
  }

  updateStoredMeta(hash, updateMeta) {
    return this.SwarmStore.updateStoredMeta(hash, updateMeta, this);
  }
  /**
   * check stored files
   * @param {any} query to lookup
   * @returns {any} stored
   */


  stored(query) {
    return this.SwarmStore.getStored(query, this).then(response => {
      return response.files;
    });
  }
  /** Get backup of wallet
   * @returns {any} file
   */


  getBackup() {
    return {
      data: JSON.stringify(this.wallet),
      name: "fds-wallet-".concat(this.subdomain, "-backup.json")
    };
  }
  /** Get backup of wallet
   * @returns {any} file
   */


  getBackupAsJSON() {
    return JSON.stringify(this.wallet);
  }
  /** get wallet file
   *  @returns {any} wallet file */


  getBackupFile() {
    return new File([JSON.stringify(this.wallet)], "fds-wallet-".concat(this.subdomain, "-backup.json"), {
      type: 'application/json'
    });
  }
  /** Save wallet backup
   *  @returns {any} result of save operation */


  saveBackupAs() {
    return (0, _fileSaver.default)(this.getBackupFile());
  }

  getMultibox(subdomain) {
    return this.Account.getMultibox(this, subdomain);
  }

  lookupContact(subdomain) {
    return this.Mail.lookupContact(this, subdomain);
  }

}

module.exports = User;